import { useEffect, useState } from "react";

/** W82 Web-5h3 (HW11, Entwurf für den Entscheid des Auftraggebers, Vorgabe aus): mit `VITE_W82_REITER_KOMPAKT=1` zieht sich die
 *  Reiterleiste am Handy beim Rollen nach unten zusammen (nur Symbole, Name nur am gewählten Reiter, Höhe der Tippfläche) und
 *  wird beim Rollen nach oben, oben auf der Seite oder beim Antippen wieder voll; wie `tabBarMinimizeBehavior(.onScrollDown)`
 *  in iOS 26. Ohne den Schalter bleibt alles wie bisher. */
export const REITER_KOMPAKT = import.meta.env.VITE_W82_REITER_KOMPAKT === "1";

/** Schwelle der Rollrichtung und Rand oben, unter dem die Leiste immer voll ist (px). */
const SCHWELLE = 8;
const OBEN = 24;

export function useReiterKompakt(an = REITER_KOMPAKT): { kompakt: boolean; voll: () => void } {
  const [kompakt, setKompakt] = useState(false);
  useEffect(() => {
    if (!an) return;
    let zuletzt = scrollY;
    let takt = 0;
    const pruefen = () => {
      takt = 0;
      const y = scrollY;
      if (y < OBEN) setKompakt(false);
      else if (y - zuletzt > SCHWELLE) setKompakt(true);
      else if (zuletzt - y > SCHWELLE) setKompakt(false);
      else return;
      zuletzt = y;
    };
    const rollen = () => {
      if (!takt) takt = requestAnimationFrame(pruefen);
    };
    addEventListener("scroll", rollen, { passive: true });
    return () => {
      removeEventListener("scroll", rollen);
      cancelAnimationFrame(takt);
    };
  }, [an]);
  return { kompakt: an && kompakt, voll: () => setKompakt(false) };
}
